/**
 * This reducer is used for maintaining the state of the progress bar
 */
import {
    SET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_CURRENT_STEP,
    RESET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_EDIT_MODE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { CONSIGNMENTINITIAL } from '../../../../constants/productConstants';

// const initialState = t('equitySteps');
const initialState = CONSIGNMENTINITIAL();

const updateProgressBarState = (state, completedStep) => {
    const newState = JSON.parse(JSON.stringify(state));
    const stepsLabels = Object.keys(newState);
    const indexOfCurrentStep = stepsLabels.findIndex(
        (stepLabel) => stepLabel === completedStep
    );

    if (newState[stepsLabels[indexOfCurrentStep + 1]]) {
        newState[stepsLabels[indexOfCurrentStep + 1]].progress = 100;
        if (newState[stepsLabels[indexOfCurrentStep + 2]])
            newState[stepsLabels[indexOfCurrentStep + 2]].progress = newState[
                stepsLabels[indexOfCurrentStep + 2]
            ].progress
                ? newState[stepsLabels[indexOfCurrentStep + 2]].progress
                : 50;
        newState[stepsLabels[indexOfCurrentStep + 1]].current = true;
        newState[stepsLabels[indexOfCurrentStep + 1]].done = false;
    }

    newState[completedStep].current = false;
    newState[completedStep].done = true;
    return newState;
};

const setProgressBarCurrentStep = (state, currentStep) => {
    const newState = JSON.parse(JSON.stringify(state));
    Object.keys(newState).forEach((step) => {
        if (step === currentStep) {
            newState[step].current = true;
        } else {
            newState[step].current = false;
        }
    });
    return newState;
};

const progressBarReducer = (state = initialState, action) => {
    // const { t } = useTranslation();
    switch (action.type) {
        case SET_PROGRESS_BAR_STATUS:
            return {
                ...updateProgressBarState(state, action.payload),
            };
        case SET_PROGRESS_BAR_CURRENT_STEP:
            return {
                ...setProgressBarCurrentStep(state, action.payload),
            };
        case RESET_PROGRESS_BAR_STATUS:
            return {
                ...initialState,
            };
        case SET_PROGRESS_BAR_EDIT_MODE:
            return action.payload;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentBillingProgressBarKey',
        storage: storage,
    },
    progressBarReducer
);
